export default __webpack_public_path__ + "static/media/culture_assessment.8e4b41ca.png";